import api from 'Application/api/api';

const updateTemplateWorkingHours = (templateId, data, cancelToken = null) =>
    api.post(`project-manager/templates/${templateId}/working-hours`, data, {
        cancelToken,
    });

export default updateTemplateWorkingHours;
